import * as React from 'react';
import { GroupType, ItemType } from '@atlaskit/single-select';

export const StatusSelectValues: GroupType[] = [
  {
    items: [
      {
        elemBefore: (
          <i className="component-status page-colors text-color operational" />
        ),
        content: 'Operational',
        value: 'operational',
      },
      {
        elemBefore: (
          <i className="component-status page-colors text-color degraded_performance" />
        ),
        content: 'Degraded Performance',
        value: 'degraded_performance',
      },
      {
        elemBefore: (
          <i className="component-status page-colors text-color partial_outage" />
        ),
        content: 'Partial Outage',
        value: 'partial_outage',
      },
      {
        elemBefore: (
          <i className="component-status page-colors text-color major_outage" />
        ),
        content: 'Major Outage',
        value: 'major_outage',
      },
      {
        elemBefore: (
          <i className="component-status page-colors text-color under_maintenance" />
        ),
        content: 'Under Maintenance',
        value: 'under_maintenance',
      },
    ],
  },
];

export const StatusSelectorHash = StatusSelectValues[0].items.reduce(
  (hash, item) => {
    hash[item.value!] = item;
    return hash;
  },
  {} as { [key: string]: ItemType },
);



// WEBPACK FOOTER //
// ./app/javascript/components/component_status_picker/StatusSelectValues.tsx